import Connection from './connection'
import Store from './store'
import api from '../api'
import { observable } from 'mobx'

export default class MlsStore extends Store {
  // TODO: remove mlsInfo and factor it out `git grep mlsInfo`  -- we should be using `records`
  @observable mlsList = []
  @observable mls = []

  constructor(scope) {
    super(new Connection('mls', scope))
  }

  loadMlsInfo(active) {
    return api.get(active ? 'mls?active=true' : 'mls').then(resp => {
      this.mlsList = this.records = resp.data.sort((a,b) => { return a.name.localeCompare(b.name) })
    })
  }

  autocompleteLabelGenerator = (record) => {
    let basicLabel = `${record.name} [${record.mls_id}]`
    if (record.legacy_mls_id) {
      basicLabel += ` (formerly ${record.legacy_mls_id})`
    }
    return basicLabel
  }

}



// WEBPACK FOOTER //
// client/stores/mls.js